import FAQAccordion from "@/components/FAQAccordion";
import TrustBar from "@/components/TrustBar";
import Seo, { faqPageSchema } from "@/components/Seo";

const PAGE_FAQ = [
    { q: "How much does it cost to make a claim?", a: "Absolutely nothing upfront. We work 100% No Win, No Fee — our success fee is capped within FCA limits (typically 18 – 30%) and only applies if we win." },
    { q: "How long does a claim take?", a: "Most claims complete in 8 – 16 weeks. Complex medical negligence or pension cases may take 6 – 18 months." },
    { q: "Is ClaimHub UK regulated?", a: "ClaimHub UK operates on an FCA-aware basis and works alongside SRA-regulated solicitor partners. We are ICO-registered for GDPR compliance." },
    { q: "What if my claim is unsuccessful?", a: "You pay nothing. No Win, No Fee means the risk sits entirely with us." },
];

export default function FAQPage() {
    return (
        <>
            <Seo
                title="Frequently asked questions"
                description="No-jargon answers to the most common questions about UK claims — fees, timelines, eligibility, regulation and what happens next."
                path="/faq"
                jsonLd={faqPageSchema(PAGE_FAQ)}
            />
            <section className="bg-navy-900 text-white relative overflow-hidden">
                <div className="absolute inset-0 bg-mesh-emerald" />
                <div className="absolute inset-0 grid-bg-dark opacity-25" />
                <div className="container-x relative py-20 lg:py-28">
                    <span className="text-eyebrow-light">FAQ</span>
                    <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-display font-bold tracking-tight">
                        Everything you wanted to ask — answered.
                    </h1>
                    <p className="mt-6 text-lg text-slate-300 max-w-2xl">No jargon, no spin — the most asked questions, answered honestly.</p>
                </div>
            </section>
            <TrustBar />
            <FAQAccordion />
        </>
    );
}
